const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms))
}

const init = () => {
    const flap_holder = document.querySelector(".split_flap_holder")

    const text_area_dom = document.querySelector("textarea")
// Eingabe im Textfeld automatisch in Großbuchstaben umwandeln
text_area_dom.addEventListener("input", () => {
    enforceTextAreaWrap();
})

// Hilfsfunktion: erzwingt Großschreibung, Zeilenbruch nach Columns
const enforceTextAreaWrap = () => {
    const cols = parseInt(columns_dom.value || 30, 10);
    const maxRows = parseInt(rows_dom.value || 5, 10);
    let raw = (text_area_dom.value || "").toUpperCase();

    let out = "";
    let lineLen = 0;
    let rowCount = 1;

    for (let i = 0; i < raw.length; i++) {
        let ch = raw[i];
        if (ch === "\r") continue; // CR ignorieren (Windows)
        if (ch === "\n") {
            // Enter: neue Zeile nur wenn noch Zeilen frei
            if (rowCount >= maxRows) break;
            out += "\n";
            rowCount++;
            lineLen = 0;
            continue;
        }
        // wenn aktuelle Zeile voll, automatisch umbrechen
        if (lineLen >= cols) {
            if (rowCount >= maxRows) break;
            out += "\n";
            rowCount++;
            lineLen = 0;
        }
        out += ch;
        lineLen++;
    }

    // Optional: Maxlength setzen, damit mobile Keyboards stoppen
    const maxLen = (cols * maxRows) + (maxRows - 1); // inkl. \n
    text_area_dom.setAttribute("maxlength", String(maxLen));

    text_area_dom.value = out;
};
    const rows_dom = document.querySelector("#rows")
    const columns_dom = document.querySelector("#columns")
    const width_dom = document.querySelector("#width")
    const height_dom = document.querySelector("#height")
    const font_size_dom = document.querySelector("#font_size")
    const scroll_delay_dom = document.querySelector("#scroll_delay")
    const alphabet_dom = document.querySelector("#alphabet")

    alphabet = " etaoinshrdlcumwfgypbvkjxqzETAOINSHRDLCUMWFGYPBVKJXQZ0123456789!.,/:@"
    split_flap_display = new SplitFlapDisplay(flap_holder, alphabet.split(''), 5, 30)

    const updateButton = document.querySelector("#updateButton");
updateButton.addEventListener("click", () => update_text());
const update_text = async () => {
  const text = text_area_dom.value;

  // altes Board raus
  if (split_flap_display && split_flap_display.holder && flap_holder.contains(split_flap_display.holder)) {
    flap_holder.removeChild(split_flap_display.holder);
  }

  // neues Board rein (nutze aktuelle Rows/Columns)
  split_flap_display = new SplitFlapDisplay(
    flap_holder,
    alphabet.split(''),
    parseInt(rows_dom.value || 5, 10),
    parseInt(columns_dom.value || 30, 10)
  );

  // erst nach dem Einfügen den Text setzen
  requestAnimationFrame(() => {
    split_flap_display.set_display(text);
  });
}
    update_text()
    enforceTextAreaWrap()

    width_dom.addEventListener("input", () => set_flap_size())
    height_dom.addEventListener("input", () => set_flap_size())
    const set_flap_size = () => {
        const width = width_dom.value
        const height = height_dom.value

        split_flap_display.set_flap_size(width, height)
    }
    set_flap_size()

    font_size_dom.addEventListener("input", () => set_font_size())
    const set_font_size = () => {
        split_flap_display.set_font_size(font_size_dom.value)
    }
    set_font_size()

    scroll_delay_dom.addEventListener("input", () => set_scroll_delay())
    const set_scroll_delay = () => {
        split_flap_display.set_scroll_delay(scroll_delay_dom.value)
    }
    set_scroll_delay()

    alphabet_dom.addEventListener("input", () => update_alphabet())
    const update_alphabet = () => {
        alphabet = " " + alphabet_dom.value
        split_flap_display.set_alphabet(alphabet)
    }
    update_alphabet()

    rows_dom.addEventListener("input", () => update_row_columns())
    columns_dom.addEventListener("input", () => update_row_columns())
    const update_row_columns = () => {
        const rows = rows_dom.value
        const columns = columns_dom.value

        flap_holder.removeChild(split_flap_display.holder)

        split_flap_display = new SplitFlapDisplay(flap_holder, alphabet.split(''), rows, columns)
        update_text()
    enforceTextAreaWrap()

        set_flap_size()
        set_font_size()
        set_scroll_delay()
    }
    update_row_columns()

    update()
}
window.onload = init

let last_time = 0
const update = (tt) => {
    requestAnimationFrame(update)

    let dt = last_time - tt
    dt = Math.max(dt, (1 / 60))

    split_flap_display.update_display(tt)

    last_time = tt
}

class SplitFlapDisplay {
    text = ""
    scroll_delay = 0

    constructor(parent, alphabet, rows, columns) {
        this.alphabet = alphabet
        this.rows = rows
        this.columns = columns

        const holder = document.createElement("div")
        holder.className = "split_flap_holder"

        this.holder = holder
        this.row_elements = []

        this.split_flaps = []

        for (let j = 0; j < rows; j++) {
            const row_element = document.createElement("div")
            row_element.classList = "split_flap_row"
            holder.appendChild(row_element)

            this.row_elements.push(row_element)

            this.split_flaps[j] = []
            for (let i = 0; i < columns; i++) {
                const new_split_flap = new SplitFlap(row_element, alphabet)

                this.split_flaps[j][i] = new_split_flap
            }
        }

        parent.appendChild(holder)
    }

    set_alphabet(alphabet) {
        this.alphabet = alphabet

        for (let j = 0; j < this.rows; j++) {
            for (let i = 0; i < this.columns; i++) {
                this.split_flaps[j][i].set_alphabet(this.alphabet)
            }
        }
    }

    set_flap_size(width, height) {
        for (let j = 0; j < this.rows; j++) {
            for (let i = 0; i < this.columns; i++) {
                this.split_flaps[j][i].set_width_height(width, height)
            }
        }
    }

    set_font_size(font_size) {
        for (let j = 0; j < this.rows; j++) {
            for (let i = 0; i < this.columns; i++) {
                this.split_flaps[j][i].set_font_size(font_size)
            }
        }
    }

    set_scroll_delay(scroll_delay) {
        this.scroll_delay = scroll_delay
    }

    update_display(tt) {
        for (let j = 0; j < this.rows; j++) {
            for (let i = 0; i < this.columns; i++) {
                this.split_flaps[j][i].update(tt)
            }
        }
    }

    async set_display(text) {
  this.text = text;
  const lines = this.text.split("\n");
  let cursor = { row: 0, column: 0 };

  for (let l = 0; l < lines.length; l++) {
    const line = lines[l];
    const chars = line.split("");

    for (let i = 0; i < chars.length; i++) {
      if (cursor.row >= this.rows) return;
      if (cursor.column >= this.columns) {
        cursor.row++;
        cursor.column = 0;
        if (cursor.row >= this.rows) return;
      }

      const flap = this.split_flaps[cursor.row][cursor.column];
      if (!flap) continue;

      const ch = this.alphabet.indexOf(chars[i]) !== -1 ? chars[i] : " ";
      flap.set_content(ch);
      cursor.column++;

      await sleep(this.scroll_delay > 0 ? this.scroll_delay : 1);
    }

    // nach Enter immer nächste Zeile
    cursor.row++;
    cursor.column = 0;
    if (cursor.row >= this.rows) break;
  }

  // restliche Felder leeren
  for (let j = cursor.row; j < this.rows; j++) {
    for (let i = cursor.column; i < this.columns; i++) {
      const flap = this.split_flaps[j][i];
      if (flap) flap.set_target_index(0);
    }
  }
}

}

class SplitFlap {
    content = ""
    time = 0

    constructor(parent, alphabet, target_index = 0) {
        this.current_index = 0
        this.target_index = target_index
        this.alphabet = alphabet

        this.anim_durration = 100

        this.element = document.createElement("div")
        this.element.className = "split_flap"

        this.top_flap = new_flap(this.element, "flap_top")
        this.bottom_flap = new_flap(this.element, "flap_bottom")
        this.anim_top_flap = new_flap(this.element, "flap_top")
        this.anim_bottom_flap = new_flap(this.element, "flap_bottom")

        this.set_flap_content(this.top_flap, this.alphabet[this.current_index], "top")
        this.set_flap_content(this.bottom_flap, this.alphabet[this.current_index], "bottom")
        this.set_flap_content(this.anim_top_flap, this.alphabet[this.current_index], "top")
        this.set_flap_content(this.anim_bottom_flap, this.alphabet[this.current_index], "bottom")

        this.set_animations()

        this.anim_top_finished = true
        this.anim_bottom_finished = true

        this.element.onclick = async () => {
            await this.anim_top.finished
            await this.anim_bottom.finished

            this.target_index = Math.round(Math.random() * this.alphabet.length)
        }


        parent.appendChild(this.element)
    }

    set_alphabet(alphabet) {
        this.alphabet = alphabet
        this.set_content(this.content)
    }

    set_width_height(width, height) {
        this.element.style.width = width + "px"
        this.element.style.height = height + "px"
    }

    set_font_size(font_size) {
        this.element.style.fontSize = font_size + "pt"
    }

    set_animations() {
        this.anim_top = this.anim_top_flap.flap.animate([{ transform: "scaleY(1)" }, { transform: "scaleY(0)" }], { duration: this.anim_durration, fill: "forwards" })
        this.anim_bottom = this.anim_bottom_flap.flap.animate([{ transform: "scaleY(0)" }, { transform: "scaleY(1)" }], { duration: this.anim_durration, fill: "forwards", delay: this.anim_durration })
    }

    update(tt) {
        this.time = tt

        if (this.current_index === this.target_index)
            return

        if (!(this.anim_top_finished && this.anim_bottom_finished)) {
            if ((this.anim_top.pending || this.anim_bottom.pending) && tt - this.anim_start_time >= this.anim_durration * 2) {
                this.anim_top.finish()
                this.anim_bottom.finish()

                this.anim_top_finished = true
                this.anim_bottom_finished = true
            }

            return
        }

        let next_index = this.current_index + 1

        if (next_index >= this.alphabet.length)
            next_index = 0

        this.animate_flaps(this.alphabet[this.current_index], this.alphabet[next_index])
        this.current_index = next_index
    }

    async animate_flaps(start_content, end_content) {
        this.anim_top_finished = false
        this.anim_bottom_finished = false
        this.anim_start_time = this.time

        this.anim_bottom_flap.flap.style.transform = "scaleY(0)"

        this.set_flap_content(this.anim_top_flap, start_content, "top")
        this.set_flap_content(this.bottom_flap, start_content, "bottom")

        this.set_flap_content(this.top_flap, end_content, "top")
        this.set_flap_content(this.anim_bottom_flap, end_content, "bottom")

        this.anim_top.play()
        this.anim_bottom.play()

        await this.anim_top.finished
        await this.anim_bottom.finished

        this.anim_top_finished = true
        this.anim_bottom_finished = true

        this.bottom_flap.container.innerHTML = end_content
    }

    set_target_index(target_index) {
  if (!this.alphabet || this.alphabet.length === 0) {
    this.target_index = 0;
    return;
  }
  this.target_index = ((target_index % this.alphabet.length) + this.alphabet.length) % this.alphabet.length;
}


    set_content(content) {
        this.content = content

        let i = this.alphabet.indexOf(content)
        if (this.target_index === i)
            return false

        this.target_index = Math.max(i, 0)
        return true
    }

    set_flap_content(flap, content, side) {
        if (!content)
            return

        flap.container.innerHTML = content

        if (content === content.toLowerCase()) {
            flap.container.style.transform = `translateY(${side === "top" ? "43" : "-57"}%)`
        } else {
            flap.container.style.transform = `translateY(${side === "top" ? "" : "-"}50%)`
        }
    }
}

const new_flap = (parent, className) => {
    let flap = document.createElement("div")
    flap.className = className
    parent.appendChild(flap)

    let container = document.createElement("div")
    container.className = "container"
    flap.appendChild(container)

    return {
        flap: flap,
        container: container
    }
}